import React from "react";
import './BMCVersionUp.css';
import EcoProButton from "../../../components/shared/button/button";

const BMCVersionUp = () => {
    return (
        <div className="bmc-version-up-wrapper">
            <p>UPDATE REQUIRED</p>
            <div className="content">
                <h1>App Update Required!</h1>
                <p>A new version of our app is available with improved performance and new features. Update now for the best experience and latest enhancements.</p>
            </div>
            <div className="new-features-list-wrapper">
                <h3>NEW FEATURES</h3>
                <div className="new-features-card-wrapper">
                    <h5 className="title">Access to your Printer Dashboard</h5>
                    <p className="desc">New Feature Text...</p>
                </div>
                <div className="new-features-card-wrapper">
                    <h5 className="title">Extended Warranty on all New Devices*</h5>
                    <p className="desc">New Feature Text...</p>
                </div>
                <div className="new-features-card-wrapper">
                    <h5 className="title">Get Exclusive Notifications?</h5>
                    <p className="desc">New Feature Text...</p>
                </div>
            </div>
            <EcoProButton cname='default'>Update Now</EcoProButton>
        </div>
    )
}

export default BMCVersionUp;